import { ExecutiveReportsSelectedOrganizationState } from '@pages/executive-reports/store/states/executive-reports-selected-organization.state';
import { ExecutiveReportsOrganizationNameOptionsState } from '@pages/executive-reports/store/states/executive-reports-organization-name-options.state';
import { ExecutiveReportsMetricTypesState } from '@pages/executive-reports/store/states/executive-reports-metric-types.state';
import { ExecutiveReportsParticipantModulesState } from '@pages/executive-reports/store/states/executive-reports-participant-modules.state';
import { ExecutiveReportsSettingsState } from '@pages/executive-reports/store/states/executive-reports-settings.state';

export const executiveReportStates = [
  ExecutiveReportsSelectedOrganizationState,
  ExecutiveReportsOrganizationNameOptionsState,
  ExecutiveReportsMetricTypesState,
  ExecutiveReportsParticipantModulesState,
  ExecutiveReportsSettingsState,
];
